import { render } from "./contact.vue?vue&type=template&id=706e6af2&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=706e6af2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\McCoy\\Desktop\\Coding\\Work\\caby_landing_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706e6af2"]])

export default __exports__